/**
 * @generated SignedSource<<62302cb03030ecc07e7c12ec4419014c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MarketingViewQuery$variables = Record<PropertyKey, never>;
export type MarketingViewQuery$data = {
  readonly marketingEmails: ReadonlyArray<{
    readonly id: string;
  }>;
};
export type MarketingViewQuery = {
  response: MarketingViewQuery$data;
  variables: MarketingViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MarketingEmail",
    "kind": "LinkedField",
    "name": "marketingEmails",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MarketingViewQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MarketingViewQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "afe6d0ba640c40e94952adab38a25f72",
    "id": null,
    "metadata": {},
    "name": "MarketingViewQuery",
    "operationKind": "query",
    "text": "query MarketingViewQuery {\n  marketingEmails {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "462f6ba8061c6ea9859de6ac17b1bdbd";

export default node;
